import type { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { ProjectExpenseRepository } from "@project/data/repositories/project-expense.repository";
import { ExpenseAllTypes } from "@project/domain/models/expenses/expense.model";
import { inject, injectable } from "inversify";
import { CreateExpenseAllTypes } from "../../models/expenses/create-expense.model";

@injectable()
export class CreateExpenseUseCase {
    constructor(
        @inject(ProjectExpenseRepository)
        private readonly projectExpenseRepository: ProjectExpenseRepository,
    ) {}

    async execute(
        expense: Nullable<CreateExpenseAllTypes>,
    ): Promise<Nullable<ExpenseAllTypes>> {
        if (expense === null) {
            return null;
        }

        const expenseCreated =
            await this.projectExpenseRepository.create(expense);
        if (expenseCreated.isLeft()) {
            ToastManagerStore.error(expenseCreated.getLeftOrThrow().message);
        } else {
            ToastManagerStore.success();
        }

        return expenseCreated.fold(
            () => null,
            (createdExpense: Nullable<ExpenseAllTypes>) => createdExpense,
        );
    }
}
